import React, { useState } from "react";
import { Button } from "@mui/material";
import "./TopBar.scss";
import PerformanceModal from "../PerformanceModal/PerformanceModal";
import { FiSearch } from "react-icons/fi";

export default function TopBar({
  onFilterClick,
  // onPublishClick,
  activeFiltersCount,
}) {

  const [openPerformance, setOpenPerformance] = useState(false);

  return (
    <>
      <div className="top-bar">
        <div className="search-wrapper">

 {/* <div className="search-box">
  <span className="search-icon"><FiSearch /></span>
        <input
          type="text"
          placeholder="Search Coin e.g. Bitcoin"
         
        />
      </div> */}


       <div className="search-bar">
        {/* <span className="search-icon"><FiSearch /></span> */}
        <input
          type="text"
          placeholder="Search Coin e.g. Bitcoin"
        />
      </div>
        </div>

        <div className="topbar-buttons">

          <Button
            variant="contained"
            onClick={() => setOpenPerformance(true)}
          >
            Performance
          </Button>

          {/* <Button
            variant="contained"
            onClick={onPublishClick}
          >
            + Publish
          </Button> */}

        </div>

      </div>

      <PerformanceModal
        open={openPerformance}
        onClose={() => setOpenPerformance(false)}
      />
    </>
  );
}